//@flow

import { getCookie, setCookie } from "react-simple-cookie-store"
import { LOCALE_EN, LOCALE_COOKIE } from "./constants"

export type Locale = "en-US" | "es-ES"

type ActionType = "Intl/SET_LOCALE"

type IntlAction = {
  type: ActionType,
  payload: {
    locale: Locale
  }
}

type IntlState = {
  +locale: Locale
}

export type SetLocale = (locale: Locale) => IntlAction

export const setLocale = (locale: Locale): IntlAction => {
  setCookie(LOCALE_COOKIE, locale, 365)
  return {
    type: "Intl/SET_LOCALE",
    payload: { locale }
  }
}

export const currentLocale = (state: { intl: IntlState }): Locale =>
  state.intl.locale

export const reducer = (state: IntlState, action: IntlAction): IntlState => {
  switch (action.type) {
    case "Intl/SET_LOCALE":
      return { ...state, locale: action.payload.locale || state.locale }
    default:
      return state || { locale: getCookie(LOCALE_COOKIE) || LOCALE_EN }
  }
}



// WEBPACK FOOTER //
// ./src/Intl/redux.js